/**
 * @license Redux-Typed-Actions v0.1.4
 * (c) 2017 Amin Paks <amin.pakseresht@hotmail.com>
 * License: MIT
 */
import { factory } from './factory';
import { ActionTypes } from './types';
import { defineClassActionProperties, generateClassAction } from './utils';
const { defineProperties } = Object;
/**
 *
 * @template Payload
 * @param {?} actionTypeName
 * @return {?}
 */
export function defineAction(actionTypeName) {
    const /** @type {?} */ prefixedActionTypeName = factory.getTypeName(actionTypeName, ActionTypes.empty);
    const /** @type {?} */ classAction = generateClassAction(prefixedActionTypeName);
    const /** @type {?} */ getMethod = (payload = undefined, meta = undefined, error = false) => {
        return {
            type: actionTypeName,
            payload,
            meta,
            error,
        };
    };
    defineClassActionProperties(classAction, actionTypeName, getMethod);
    return /** @type {?} */ (classAction);
}
/**
 *
 * @template Payload, SuccessPayload, FailurePayload, CancelPayload
 * @param {?} actionTypeName
 * @return {?}
 */
export function defineScenarioAction(actionTypeName) {
    const /** @type {?} */ startActionTypeName = factory.getTypeName(actionTypeName, ActionTypes.start);
    const /** @type {?} */ cancelActionTypeName = factory.getTypeName(actionTypeName, ActionTypes.cancel);
    const /** @type {?} */ successActionTypeName = factory.getTypeName(actionTypeName, ActionTypes.success);
    const /** @type {?} */ failureActionTypeName = factory.getTypeName(actionTypeName, ActionTypes.failure);
    const /** @type {?} */ startClassAction = generateClassAction(startActionTypeName);
    const /** @type {?} */ cancelClassAction = generateClassAction(cancelActionTypeName);
    const /** @type {?} */ successClassAction = generateClassAction(successActionTypeName);
    const /** @type {?} */ failureClassAction = generateClassAction(failureActionTypeName);
    const /** @type {?} */ getMethod = (type = '', error = false, payload = undefined, meta = undefined) => {
        return {
            type,
            payload,
            meta,
            error,
        };
    };
    defineClassActionProperties(startClassAction, startActionTypeName, getMethod.bind(null, startActionTypeName, false));
    defineClassActionProperties(cancelClassAction, cancelActionTypeName, getMethod.bind(null, cancelActionTypeName, false));
    defineClassActionProperties(successClassAction, successActionTypeName, getMethod.bind(null, successActionTypeName, false));
    defineClassActionProperties(failureClassAction, failureActionTypeName, getMethod.bind(null, failureActionTypeName, true));
    defineProperties(startClassAction, {
        /**
         * Returns a simple class action for cancel
         */
        cancel: {
            writable: false,
            enumerable: false,
            configurable: false,
            value: cancelClassAction,
        },
        /**
         * Returns a simple class action for success
         */
        success: {
            writable: false,
            enumerable: false,
            configurable: false,
            value: successClassAction,
        },
        /**
         * Returns a simple class action for failure
         */
        failure: {
            writable: false,
            enumerable: false,
            configurable: false,
            value: failureClassAction,
        },
    });
    return /** @type {?} */ (startClassAction);
}
/**
 *
 * @template P
 * @param {?} actionTypeName
 * @return {?}
 */
export function defineSymbolAction(actionTypeName) {
    return /** @type {?} */ (defineAction(/** @type {?} */ (Symbol(actionTypeName))));
}
